import { Switch as SwitchPrimitive } from "@base-ui/react/switch";

import { focusStyles } from "@beweegbaas/ui/lib/focus-styles";
import { cnState } from "@beweegbaas/ui/lib/utils";

function Switch({
  className,
  size = "default",
  ...props
}: SwitchPrimitive.Root.Props & {
  size?: "sm" | "default";
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cnState(
        [
          `data-checked:bg-success aria-invalid:ring-destructive/20
          dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive
          dark:aria-invalid:border-destructive/50 peer
          group/switch relative inline-flex shrink-0
          items-center rounded-full border
          border-transparent shadow-xs
          transition-all after:absolute after:-inset-x-3 after:-inset-y-2
          aria-invalid:ring-[3px] data-disabled:cursor-not-allowed data-disabled:opacity-50 data-unchecked:bg-black/10 data-[size=default]:h-[18.4px]
          data-[size=default]:w-[32px] data-[size=sm]:h-[14px] data-[size=sm]:w-[24px]
          dark:data-unchecked:bg-white/15`,
          focusStyles,
        ],
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="dark:data-unchecked:bg-foreground dark:data-checked:bg-primary-foreground pointer-events-none
          block
          rounded-full bg-linear-to-b
          from-white/90
          to-white
          shadow
          ring-0
          transition-transform
          group-data-[size=default]/switch:size-3.5
          group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[calc(100%-0px)] group-data-[size=sm]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=default]/switch:data-unchecked:translate-x-[calc(0%+2px)] group-data-[size=sm]/switch:data-unchecked:translate-x-0"
      />
    </SwitchPrimitive.Root>
  );
}

// Export SwitchPrimitive for advanced use cases
export { Switch, SwitchPrimitive };
